import { getAdminMenu } from './adminMenu'
import { componentLibraryMenu, isComponentLibraryMenu } from './componentLibraryMenu'
import { useEmployeeMenu } from './employeeMenu'
import { MenuItem } from './types'
import { useTranslation } from 'react-i18next'

export const useGetMenu = (showAdminMenu: boolean, currentRoute?: string): MenuItem[] => {
  const { t } = useTranslation()
  const employeeMenu = useEmployeeMenu(t)
  const adminMenu = getAdminMenu(t)
  if (currentRoute && isComponentLibraryMenu(currentRoute)) {
    return componentLibraryMenu
  } else if (showAdminMenu) {
    return adminMenu
  } else {
    return employeeMenu
  }
}
